import axios from 'axios'
import * as utils from './api-utils'

export default {
  index() {
    return axios.get(utils.getApiUrl('/admin/users'))
  },
  register(data) {
    return axios.post(utils.getApiUrl('/admin/register'), data)
  },
  updatePassword(data) {
    return axios.post(utils.getApiUrl('/admin/password'), data)
  },
  bulkDelete(data) {
    return axios.post(utils.getApiUrl('/admin/bulkDelete'), data)
  },
  myOfficeStaffs() {
    return axios.get(utils.getApiUrl('/admin/users/myOfficeStaffs'))
  },
  getAllUser() {
    return axios.get(utils.getApiUrl('/admin/users/getAllUser'))
  },
  getIsAdmin() {
    return axios.get(utils.getApiUrl('/admin/users/getIsAdmin'))
  },
  getUser(id) {
    return axios.get(utils.getApiUrl(`/admin/users/${id}`))
  },
  updateCustomerProfile(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/customerProfile`), data)
  },
  updateAvailableRequestCount(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/availableRequestCount`), data)
  },
  getReceipts() {
    return axios.get(utils.getApiUrl('/admin/users/receipts'), { responseType: 'blob' })
  },
  updateReceipt(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/receipt`), data)
  },
  updateInvoiceIssuanceMethod(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/invoiceIssuanceMethod`), data)
  },
  updateInvoiceId(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/invoiceId`), data)
  },
  updateManagementNotes(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/managementNotes`), data)
  },
  updateSat(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/sat`), data)
  },
  updateWashType(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/washType`), data)
  },
  updateFoldType(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/foldType`), data)
  },
  updateStatus(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/status`), data)
  },
  updateRole(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/role`), data)
  },
  updateWashWeight(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/washWeight`), data)
  },
  updateWeight(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/weight`), data)
  },
  updateDispatchPlanStartTime(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/dispatchPlanSettings/arrivalStartTime`), data)
  },
  updateDispatchPlanDeadlineTime(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/dispatchPlanSettings/arrivalDeadlineTime`), data)
  },
  updateDispatchPlanPickupCount(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/dispatchPlanSettings/pickupCount`), data)
  },
  updateDispatchPlanTaskDurationMinutes(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/dispatchPlanSettings/taskDurationMinutes`), data)
  },
  updateDispatchPlanIsDispatchExcluded(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/dispatchPlanSettings/isDispatchExcluded`), data)
  },
  delete(id) {
    return axios.delete(utils.getApiUrl(`/admin/users/${id}`))
  },
  getUserCurrentPlan(id) {
    return axios.get(utils.getApiUrl(`/admin/users/${id}/currentUserPlan`))
  },
  updateUserPlan(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/userPlan`), data)
  },
  updateHasOilTreatment(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/hasOilTreatment`), data)
  },
  updateLaundryType(id, data) {
    return axios.post(utils.getApiUrl(`/admin/users/${id}/laundryType`), data)
  },
}
